import requestMethods from '@/helpers/request/requestMethods';
import { addContentLogApiConfig, viewApiConfig } from '@/constants/ApiUrls';

function postContentView({ objectType, objectId, tags, sourcePageData, userAgentData }) {
    return requestMethods
        .post({
            routeConfig: viewApiConfig(objectType, objectId),
            data: {
                tags,
                details: {
                    ...(sourcePageData && sourcePageData),
                    ...(userAgentData && userAgentData)
                }
            }
        })
        .then((resp) => resp?.data);
}

function postContentLog({ objectType, objectId, data, tags }) {
    return requestMethods.post({
        routeConfig: addContentLogApiConfig(objectType, objectId),
        data: { ...data, tags }
    });
}

export { postContentView, postContentLog };
